import React, { useCallback, useState } from 'react';
import './sign-token-redemption-footer.scss';
import { ArrowLeft, EditIcon } from 'assets/icons';
import { PrivateKeyButton } from 'components';
import { IconBtn } from '@ru-digital-assets/ui-component';

interface IInitTokenRedemptionFooter {
  onCancel?: () => void;
  onSign: (privateKey: string) => void;
  label: string | React.ReactNode;
}

export default function SignTokenRedemptionFooter({
  onCancel,
  onSign,
  label,
}: IInitTokenRedemptionFooter) {
  const [privateKey, setPrivateKey] = useState<string>();

  const onSignClick = useCallback(() => {
    onSign(privateKey!);
  }, [onSign, privateKey]);

  return (
    <div
      className="sign-token-redemption-footer"
      style={{
        justifyContent: onCancel ? 'space-between' : 'flex-end',
      }}
    >
      {onCancel && (
        <div
          className="sign-token-redemption-footer__cancel-button"
          role="button"
          onClick={onCancel}
        >
          <ArrowLeft color="#fff" />
          <span className="p p_color_white">Вернуться</span>
        </div>
      )}
      <div className="flex align-center">
        <p style={{ textAlign: 'right' }} className="p p_color_white mr_10">
          {label}
        </p>
        <div className="sign-token-redemption-footer__key-button">
          <PrivateKeyButton onKeyChange={(key) => setPrivateKey(key)} />
        </div>
        <div className="sign-token-redemption-footer__sign-button">
          <IconBtn
            title="Подписать транзакцию и инициировать погашение"
            icon={<EditIcon color="#fff" />}
            onClick={onSignClick}
            disabled={!privateKey}
          />
        </div>
      </div>
    </div>
  );
}
